import React from 'react';
import { Doughnut } from 'react-chartjs-2';
const PieChart = ({ chartData }: any) => {
  return <Doughnut data={chartData} />;
};

export default PieChart;
